// import { Injectable } from '@angular/core';
// import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
// import { FormGroup } from '@angular/forms';

// @Injectable()
// export class CustomValidationService {

//   constructor() { }



//   checkAmount(amount: any) {
//     return (formGroup: AbstractControl): ValidationErrors | null => {
//       const amountControl = formGroup.get(amount);
      

//       if (!amountControl) {
//         return null;
//       }

//       if (
//         amountControl.errors &&
//         !amountControl.errors["amountValidation"]
//       ) {
//         return null;
//       }

//       if (amountControl.value % 100 !== 0) {
//         amountControl.setErrors({ amountValidation: true });
//         return { amountValidation: true };
//       } else {
//         amountControl.setErrors(null);
//         return null;
//       }
//     };
//   }
// }

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const amountValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value % 100 !== 0) {
      return { invalidAmount: false };
    }
    else{
      return null; // passes the test, return null to clear any errors
     }
  };
};

export function rechargeAmountValidator(control: AbstractControl) {
  if (control.value % 100 !== 0) {
    return { amountValid: false };
  }
  return null;
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/custom-validation/custom-validation.service.ts